import { render } from "./CheckoutSideItem01.vue?vue&type=template&id=6afea867&scoped=true"
import script from "./CheckoutSideItem01.vue?vue&type=script&lang=js"
export * from "./CheckoutSideItem01.vue?vue&type=script&lang=js"

import "./CheckoutSideItem01.vue?vue&type=style&index=0&id=6afea867&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6afea867"]])

export default __exports__